import { h, onMounted, ref, render } from 'vue'
import { ToastOptions } from './toastOptions'
import ToastContainer from './ToastContainer.vue'

const toasts = ref<ToastOptions[]>([])
let el: HTMLDivElement | null = null

export function useToastProvider() {
    onMounted(() => {
        if (!el) {
            el = document.createElement('div')
            el.className = 'toast-container p-3 start-50 translate-middle-x'
            el.style.position = 'fixed'
            el.style.zIndex = '1000'
            const vNode = h(ToastContainer)
            document.body.prepend(el)
            render(vNode, el)
        }
    })

    return {
        toasts
    }
}